import { TEntityGridColumn } from 'app/common/entity-grid/core';
import { TTicketOrder } from 'app/railways/domains/tickets/core/tickets-order';

export const cols: TEntityGridColumn<TTicketOrder>[] = [
  {
    field: 'id',
    headerName: 'ID',
    minWidth: 50,
    headerCheckboxSelection: false,
    checkboxSelection: false,
    sortable: true,
    comparator: () => 0,
  },
  {
    // @ts-expect-error ...
    field: 'nameRu',
    headerName: 'Название',
    sortable: false,
    colId: 'nameRu',
    comparator: () => 0,
  },
];
